import styled from '@emotion/styled'

export const StyledTableHeader = styled.thead``

export const StyledHeaderCell = styled.th`
  padding: 18px;
  text-align: left;
  background-color: #ffffff;
  color: #8b8a90;
  font-size: 0.75em;
  font-family: 'proxima-nova', sans-serif;
`

export const StyledRow = styled.tr`
  border-bottom: 1px solid #e9e9eb;
}
`
